import { forwardRef } from 'react';

import { TextAnimate } from '@shared/ui/text-animate';
import { Heading } from '@shared/ui/typography';

interface LandingProductsTextProps {
  headingId: string;
  label: string;
  heading: string;
  animate: boolean;
}

export const LandingProductsText = forwardRef<HTMLSpanElement, LandingProductsTextProps>(
  ({ headingId, label, heading, animate }, ref) => {
    const ease = [0.22, 1, 0.36, 1] as const;

    return (
      <div className="relative">
        <div
          className="
            absolute top-1/2 left-1/2 h-[400%] w-screen -translate-1/2 bg-linear-to-b
            from-background-2/0 from-0% to-background-2 to-35%
          "
        />
        <p
          className="
            relative ms-px mb-2 text-sm/5 font-medium text-primary
            md:ms-0.5 md:text-base/6
            lg:ms-1
          "
        >
          <TextAnimate
            as="span"
            animation="slideUp"
            animate={animate ? 'show' : 'hidden'}
            duration={0.2}
            delay={0.1}
            enterTransition={{ duration: 1.3, ease }}
            by="word"
            className="block"
            initial="hidden"
            startOnView={false}
            once={true}
          >
            {label}
          </TextAnimate>
        </p>
        <Heading
          tag="h2"
          id={headingId}
          size="6xl"
          className="relative font-medium text-foreground"
        >
          <span ref={ref} className="block">
            <TextAnimate
              as="span"
              animation="slideUp"
              animate={animate ? 'show' : 'hidden'}
              duration={0.15}
              delay={0.2}
              enterTransition={{ duration: 1.3, ease }}
              by="word"
              className="block"
              initial="hidden"
              startOnView={false}
              once={true}
            >
              {heading}
            </TextAnimate>
          </span>
        </Heading>
      </div>
    );
  }
);

LandingProductsText.displayName = 'LandingProductsText';
